export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/arrow.901a9e46.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};